import { filter, OperatorFunction } from "rxjs";

export function isNotNullOrUndefined<T>(): OperatorFunction<
    T,
    Exclude<T, null | undefined>
> {
    return filter(
        (value): value is Exclude<T, null | undefined> =>
            value !== null && value !== undefined,
    );
}
